import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useTemplate } from './_load/TemplateLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('templates')
  const template = useTemplate()
  const context = !!template?.id && 'edit'
  const title = t('modalTitle', { context })
  return (
    <>
      <Title size="h4" color={COLORS.dark2} noMargin>
        {title}
      </Title>
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
